"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function () {
    return _ChipsComponent.default;
  }
});

var _ChipsComponent = _interopRequireDefault(require("./Chips-component"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }